import { get, writable } from "svelte/store";
import type { ProductLineListingStoreContents } from "@shared/types/ProductLine";

export enum ProductListingLayout {
  Grid = "grid",
  List = "list",
}

export const PRODUCT_LISTING_LIMITS = [36, 72, 100];

export const DEFAULT_LAYOUT = ProductListingLayout.List;
export const DEFAULT_LIMIT = 20;

export const CURRENT_LAYOUT_KEY = "product_list_layout";
export const CURRENT_LIMIT_KEY = "product_list_limit";

const defaultProductListLimit = () => {
  let limit = +sessionStorage.getItem(CURRENT_LIMIT_KEY);
  return PRODUCT_LISTING_LIMITS.includes(limit) ? limit : DEFAULT_LIMIT;
};

const defaultStoreState: ProductLineListingStoreContents = {
  accordionStatesParamsKey: null,
  discountData: {},
  filtersCount: 0,
  listViewAccordionStates: {},
  loadingPrices: true,
  mobileFiltersVisible: false,
  onApplyFilters: null,
  onClearAllFilters: null,
  onClearFilter: null,
  productData: {},
  productLineFuturePrices: {},
  inventoryPrices: [],
  productLines: [],
  productListLayout: (sessionStorage.getItem(CURRENT_LAYOUT_KEY) ||
    DEFAULT_LAYOUT) as ProductListingLayout,
  productListLimit: defaultProductListLimit(),
  productsFound: false,
  selectedFilters: [],
};

export const ProductLineListingStore = writable(defaultStoreState);

const updateLimitKey = () => {
  const limit = get(ProductLineListingStore).productListLimit;
  if (
    PRODUCT_LISTING_LIMITS.includes(limit) &&
    limit !== +sessionStorage.getItem(CURRENT_LIMIT_KEY)
  ) {
    sessionStorage.setItem(CURRENT_LIMIT_KEY, limit.toString());
  }
};

const setCurrentLayoutSetting = () => {
  let currentSelectedLayout = sessionStorage.getItem(CURRENT_LAYOUT_KEY);

  if (!currentSelectedLayout || currentSelectedLayout === "undefined") {
    currentSelectedLayout = DEFAULT_LAYOUT;
  }

  sessionStorage.setItem(CURRENT_LAYOUT_KEY, currentSelectedLayout);
  ProductLineListingStore.update(n => {
    n.productListLayout = currentSelectedLayout as ProductListingLayout;
    return n;
  });
};

export const updateProductLineListingStore = (updateFunc: any) => {
  setCurrentLayoutSetting();
  updateLimitKey();
  ProductLineListingStore.update(updateFunc);
};
